/**
 * The DMS wordmark: a card-catalogue drawer (index cards peeking out, a label holder
 * with the red catalogue rule, the pull) beside the product name. Rename or swap the
 * logo in config/brand.ts.
 */
import { BRAND } from '../../config/brand';
import { cx } from '../../components/ui';

export function DrawerGlyph({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 32 32" aria-hidden className={className}>
      <rect x="7" y="3" width="18" height="10" rx="1" fill="rgb(var(--card))" stroke="rgb(var(--line-strong))" strokeWidth="1" />
      <rect x="9.5" y="5.5" width="18" height="8" rx="1" fill="rgb(var(--card))" stroke="rgb(var(--line-strong))" strokeWidth="1" transform="rotate(4 18 9)" />
      <rect x="3" y="11" width="26" height="18" rx="2.5" fill="rgb(var(--brand))" />
      <rect x="9" y="14.5" width="14" height="6" rx="1" fill="rgb(var(--card))" />
      <path d="M10.5 18.6h11" stroke="rgb(var(--rule))" strokeWidth="1.2" />
      <circle cx="16" cy="24.6" r="1.9" fill="rgb(var(--card))" />
    </svg>
  );
}

export function Wordmark({ compact, className }: { compact?: boolean; className?: string }) {
  if (BRAND.logoUrl) return <img src={BRAND.logoUrl} alt={BRAND.product} className={cx('h-8 w-auto', className)} />;
  return (
    <span className={cx('inline-flex items-center gap-2.5', className)}>
      <DrawerGlyph className="h-8 w-8 shrink-0" />
      {!compact && <span className="display whitespace-nowrap text-[19px] text-ink">{BRAND.product}</span>}
    </span>
  );
}
